import { jsx as _jsx } from "react/jsx-runtime";
import { OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import { AccountsPlugin } from "@gearbox-protocol/sdk/plugins/accounts";
import { createContext, useContext, useMemo } from "react";
import { custom } from "viem";
const SDKContext = createContext(null);
const fakeTransport = custom({ request: () => Promise.resolve(null) });
export const HydratedSDKProvider = ({ state, children, }) => {
    const sdk = useMemo(() => {
        const instance = new OnchainSDK(state.network, {
            transport: fakeTransport,
        }, {
            plugins: { accounts: new AccountsPlugin() },
        });
        // hydrate() mutates the passed-in state; clone it so we don't mutate the
        // same object that lives in the Redux store (it's shared via report.sdkState)
        instance.hydrate(structuredClone(state));
        return instance;
    }, [state]);
    return _jsx(SDKContext.Provider, { value: sdk, children: children });
};
export const useHydratedSDK = () => useContext(SDKContext);
